/* ═══════════════════════════════════════════════════════════════════════
   ISOFIN — Voice-Player (v359, 2026-07-03 · v478 2026-07-15: Per-Page-Events)
   ───────────────────────────────────────────────────────────────────────
   Super-einfacher Audio-Player für die Voice-Notizen (Zielgruppe 45–65):
   KOMPAKT (eine Zeile, WhatsApp-Look): Play-Knopf · Waveform · Tempo-Pille.
   Die Tempo-Pille schaltet beim Tippen durch (1× → 1,25× → 1,5× → 1×,
   konfigurierbar via data-rates) — playbackRate, Tonhöhe bleibt normal.

   Einbau (beliebig oft pro Seite, z. B. Startseite Block 2):
     <div class="iso-voice" data-iso-voice
          data-src="https://…/datei.mp3"
          data-title="In einer Minute erklärt: …"
          data-track="home"
          style="min-height:96px"></div>
     <script src="…/iso-voice-player.js" defer></script>

   • preload="none": lädt NICHTS bis zum ersten Play (0 Performance-Kosten)
   • v370: CSS-Selektoren gedoppelt (.ivp.ivp …) — überlebt *-Resets wie den
     .iso-fl-Container der Lösungsseiten (Body-Style schlägt sonst Head-Style)
   • Nur ein Player spielt gleichzeitig (andere pausieren automatisch)
   • logr3: voice_play {page,rate,pos} · voice_complete {page,rate}
            · voice_rate {page,rate}
   • v478: zusätzlich seiten-spezifische Events voice_play_<page> /
     voice_complete_<page> (home|product|ergebnis|loesung). Die Counts-API
     zählt nur nach Event-Namen — so wird Abspiel-/Completion-Rate PRO SEITE
     direkt zählbar. Summe voice_play_<page> == voice_play (keine Doppelzählung).
   ═══════════════════════════════════════════════════════════════════════ */
(function (w, d) {
  "use strict";

  /* v399 (Björn): Solange irgendein Voice-Player spielt, trägt <body> die
     Klasse iso-voice-live — Seiten können damit z. B. den Sticky-Footer
     ausblenden (Ergebnisseite: Sticky verdeckte den Player). */
  var allAudios = [];
  function syncLiveClass() {
    var live = false;
    for (var i = 0; i < allAudios.length; i++) {
      if (!allAudios[i].paused && !allAudios[i].ended) { live = true; break; }
    }
    try { d.body.classList[live ? "add" : "remove"]("iso-voice-live"); } catch (e) {}
  }
  if (w.__ISO_VOICE_PLAYER__) return;
  w.__ISO_VOICE_PLAYER__ = 1;

  var DEFAULT_RATES = [1, 1.25, 1.5];
  function parseRates(host) {
    var raw = host.getAttribute("data-rates");
    if (!raw) return DEFAULT_RATES;
    var out = [];
    raw.split(",").forEach(function (x) { var v = parseFloat(String(x).trim().replace(",", ".")); if (v > 0 && v <= 3) out.push(v); });
    return out.length ? out : DEFAULT_RATES;
  }

  function track(ev, data) {
    /* A6: ohne step landet das Event auf /goal und faelscht den Kauf-Zaehler "converted". */
    try { if (typeof w.logr3Track === "function") w.logr3Track(ev, Object.assign({ step: true }, data || {})); } catch (e) {}
  }

  /* v478: zusätzlich zum generischen Event einen seiten-spezifischen Namen
     feuern (voice_play_home, voice_complete_product …). Die Logr3-Counts-API
     zählt nur nach Event-Namen — so wird die Abspiel-/Completion-Rate PRO SEITE
     direkt zählbar, ohne die API anzufassen. Slug wird auf [a-z0-9_] normiert;
     leere/unbekannte Seite → nur das generische Event (Summe bleibt konsistent). */
  function trackPaged(ev, page, data) {
    track(ev, data);
    var p = String(page || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    if (p) track(ev + "_" + p, data);
  }

  var CSS = "" +
    ".ivp.ivp{display:flex;align-items:center;gap:12px;max-width:480px;box-sizing:border-box;background:#fff;border:1px solid #ececec;border-radius:999px;padding:8px 16px 8px 8px;box-shadow:0 10px 28px rgba(0,0,0,.10);font-family:Rubik,-apple-system,sans-serif}" +
    ".ivp-btn.ivp-btn{flex:0 0 auto;width:48px;height:48px;border:none;border-radius:50%;background:linear-gradient(135deg,#FF2D46 0%,#D6001C 100%);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;transition:filter .15s}" +
    ".ivp-btn.ivp-btn:hover{filter:brightness(.92)}" +
    ".ivp-btn.ivp-btn svg{width:24px;height:24px;display:block}" +
    ".ivp-main.ivp-main{flex:1 1 auto;min-width:0}" +
    /* v525: 12,5px und 11,5px auf 13px angehoben — Mindestgröße für die Zielgruppe 45+. */
    ".ivp-title.ivp-title{margin:0 0 3px !important;font-size:13px !important;font-weight:500 !important;color:#6b6b6b !important;line-height:1.3 !important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
    ".ivp-wave.ivp-wave{display:flex;align-items:center;gap:2px;height:30px;cursor:pointer;-webkit-tap-highlight-color:transparent}" +
    ".ivp-wb.ivp-wb{flex:1 1 auto;min-width:2px;max-width:9px;border-radius:99px;background:#d9d6d1;pointer-events:none;transition:background .12s}" +
    ".ivp-wb.ivp-wb.is-played{background:#D6001C}" +
    ".ivp-side.ivp-side{flex:0 0 auto;display:flex;flex-direction:column;align-items:center;gap:3px}" +
    ".ivp-rate.ivp-rate{border:1px solid transparent;background:#f5f4f2;color:#444;border-radius:99px;padding:7px 12px;min-height:34px;min-width:52px;font-size:13px !important;font-weight:700;cursor:pointer;font-family:inherit;-webkit-tap-highlight-color:transparent;box-sizing:border-box}" +
    ".ivp-rate.ivp-rate:hover{background:#ecebe8}" +
    ".ivp-time.ivp-time{font-size:13px !important;color:#8a8a8a;font-variant-numeric:tabular-nums;white-space:nowrap}" +
    ".ivpm.ivpm{position:fixed;left:12px;right:12px;bottom:12px;z-index:9200;max-width:440px;margin:0 auto;display:none;align-items:center;gap:10px;background:#fff;border:1px solid #e5e2dd;border-radius:14px;padding:9px 10px;box-shadow:0 10px 32px rgba(0,0,0,.22);font-family:Rubik,-apple-system,sans-serif;overflow:hidden}" +
    ".ivpm.ivpm.is-on{display:flex}" +
    ".ivpm-prog.ivpm-prog{position:absolute;top:0;left:0;height:3px;width:0%;background:#D6001C;border-radius:0}" +
    ".ivpm-btn.ivpm-btn{flex:0 0 auto;width:40px;height:40px;border:none;border-radius:50%;background:linear-gradient(135deg,#FF2D46 0%,#D6001C 100%);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;padding:0}" +
    ".ivpm-btn.ivpm-btn svg{width:20px;height:20px;display:block}" +
    ".ivpm-tx.ivpm-tx{flex:1 1 auto;min-width:0;text-align:left;background:none;border:none;padding:0;margin:0;cursor:pointer;font-family:inherit}" +
    ".ivpm-title.ivpm-title{display:block;font-size:12.5px;font-weight:500;color:#444;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:0}" +
    ".ivpm-hint.ivpm-hint{display:block;font-size:10.5px;color:#9a968f;line-height:1.3;margin:1px 0 0}" +
    ".ivpm-x.ivpm-x{flex:0 0 auto;width:36px;height:36px;border:none;border-radius:50%;background:#f2f1ef;color:#555;font-size:15px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;padding:0}";

  /* Pseudo-Waveform im WhatsApp-Stil: Höhen deterministisch aus der Datei-URL
     (kein Vorab-Laden/Dekodieren der MP3 nötig — Player bleibt bei preload=none). */
  function waveBars(src) {
    var seed = 0;
    for (var i = 0; i < src.length; i++) seed = (seed * 31 + src.charCodeAt(i)) >>> 0;
    function rnd() { seed = (seed + 0x6D2B79F5) >>> 0; var t = seed; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }
    var N = 40, raw = [], html = "";
    for (var j = 0; j < N; j++) raw.push(0.22 + rnd() * 0.78);
    for (var k = 0; k < N; k++) {
      var v = raw[k];
      if (k > 0 && k < N - 1) v = (raw[k - 1] + raw[k] * 2 + raw[k + 1]) / 4;   /* glätten → natürliches Auf/Ab */
      html += '<span class="ivp-wb" style="height:' + Math.round(7 + v * 21) + 'px"></span>';
    }
    return html;
  }

  var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h3.6v14H7zM13.4 5H17v14h-3.6z"/></svg>';

  function injectCSS() {
    if (d.getElementById("ivp-css")) return;
    var s = d.createElement("style");
    s.id = "ivp-css";
    s.textContent = CSS;
    d.head.appendChild(s);
  }

  function fmt(t) {
    if (!isFinite(t) || t < 0) return "–:––";
    var m = Math.floor(t / 60), sec = Math.floor(t % 60);
    return m + ":" + (sec < 10 ? "0" : "") + sec;
  }

  var players = [];

  /* ══ Mini-Player (v373): schwebt unten ein, wenn Audio spielt und der
     Original-Player aus dem Sichtfeld gescrollt ist. Pause + ✕ (stoppen &
     schließen) + Tipp auf den Titel = zurück zum Player. Dockt über dem
     Sticky-Warenkorb an. Ein Singleton für alle Player der Seite. ══ */
  var _bar = null, _barAudio = null, _barHost = null, _barSetIcon = null, _barPage = "";
  function ensureBar() {
    if (_bar) return _bar;
    _bar = d.createElement("div");
    _bar.className = "ivpm";
    _bar.setAttribute("role", "region");
    _bar.setAttribute("aria-label", "Audio-Steuerung");
    _bar.innerHTML = "" +
      '<span class="ivpm-prog"></span>' +
      '<button type="button" class="ivpm-btn" aria-label="Pause">' + ICON_PAUSE + "</button>" +
      '<button type="button" class="ivpm-tx" aria-label="Zum Audio-Player springen">' +
      '<span class="ivpm-title"></span><span class="ivpm-hint">Läuft weiter – tippen für Player</span></button>' +
      '<button type="button" class="ivpm-x" aria-label="Audio stoppen und schließen">✕</button>';
    d.body.appendChild(_bar);
    _bar.querySelector(".ivpm-btn").addEventListener("click", function () {
      if (!_barAudio) return;
      if (_barAudio.paused) { _barAudio.play(); trackPaged("voice_play", _barPage, { page: _barPage, rate: _barAudio.playbackRate, pos: Math.round(_barAudio.currentTime), via: "minibar" }); }
      else _barAudio.pause();
    });
    _bar.querySelector(".ivpm-x").addEventListener("click", function () {
      if (_barAudio) _barAudio.pause();
      hideBar();
      track("voice_minibar_close", { page: _barPage });
    });
    _bar.querySelector(".ivpm-tx").addEventListener("click", function () {
      if (!_barHost) return;
      try { _barHost.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) { _barHost.scrollIntoView(); }
    });
    return _bar;
  }
  function barOffset() {
    /* über dem Sticky-Warenkorb andocken, falls der sichtbar ist */
    var b = 12;
    try {
      var sw2 = d.getElementById("isofin-sw2-bar");
      if (sw2) {
        var r = sw2.getBoundingClientRect();
        if (r.height > 0 && r.top < w.innerHeight) b = Math.round(w.innerHeight - r.top) + 8;
      }
    } catch (e) {}
    _bar.style.bottom = b + "px";
  }
  function showBar(audio, host, title, page, setIcon) {
    ensureBar();
    _barAudio = audio; _barHost = host; _barPage = page; _barSetIcon = setIcon;
    _bar.querySelector(".ivpm-title").textContent = title;
    _bar.querySelector(".ivpm-btn").innerHTML = audio.paused ? ICON_PLAY : ICON_PAUSE;
    barOffset();
    _bar.classList.add("is-on");
  }
  function hideBar() { if (_bar) _bar.classList.remove("is-on"); }
  function hostInView(host) {
    try {
      var r = host.getBoundingClientRect();
      return r.bottom > 0 && r.top < w.innerHeight;
    } catch (e) { return true; }
  }
  function updateBarFor(audio, host, title, page) {
    if (audio.paused || audio.ended) { if (_barAudio === audio) hideBar(); return; }
    if (hostInView(host)) { if (_barAudio === audio) hideBar(); return; }
    showBar(audio, host, title, page);
    barOffset();   /* v374: laufend nachführen — Sticky kann später erscheinen, Handy gedreht werden */
    if (audio.duration > 0) _bar.querySelector(".ivpm-prog").style.width = ((audio.currentTime / audio.duration) * 100).toFixed(1) + "%";
  }

  function build(host) {
    if (host.getAttribute("data-ivp-ready")) return;
    host.setAttribute("data-ivp-ready", "1");
    injectCSS();

    var src = host.getAttribute("data-src");
    var title = host.getAttribute("data-title") || "Kurz anhören";
    var page = host.getAttribute("data-track") || "page";
    var rates = parseRates(host);
    if (!src) return;

    var audio = new Audio();
    allAudios.push(audio);
    audio.preload = "none";
    /* src erst beim ersten Play setzen — garantiert NULL Netzwerk-Aktivität
       (auch keine Cache-Revalidierung) vor dem Klick. Pagespeed-safe. */
    var srcSet = false;
    try { audio.preservesPitch = true; audio.mozPreservesPitch = true; audio.webkitPreservesPitch = true; } catch (e) {}

    host.innerHTML = "" +
      '<div class="ivp">' +
      '<button type="button" class="ivp-btn" aria-label="Anhören: ' + title.replace(/"/g, "&quot;") + '">' + ICON_PLAY + "</button>" +
      '<div class="ivp-main">' +
      '<p class="ivp-title">' + title + "</p>" +
      /* v599: Schieberegler mit Werten + Tastatur (Lighthouse: aria-valuenow fehlte) */
      '<div class="ivp-wave" role="slider" tabindex="0" aria-label="Abspielposition" aria-valuemin="0" aria-valuemax="0" aria-valuenow="0" aria-valuetext="0:00">' + waveBars(src) + "</div>" +
      "</div>" +
      '<div class="ivp-side">' +
      '<button type="button" class="ivp-rate" aria-label="Abspielgeschwindigkeit ändern">' + String(rates[0]).replace(".", ",") + "×</button>" +
      '<span class="ivp-time">–:––</span>' +
      "</div></div>";
    host.style.minHeight = "";

    var btn = host.querySelector(".ivp-btn");
    var wave = host.querySelector(".ivp-wave");
    var bars = wave.querySelectorAll(".ivp-wb");
    var time = host.querySelector(".ivp-time");
    var lastIdx = -1;
    function paint(pct) {
      var idx = Math.floor(pct * bars.length);
      if (idx === lastIdx) return;
      lastIdx = idx;
      for (var i = 0; i < bars.length; i++) bars[i].classList[i < idx ? "add" : "remove"]("is-played");
    }
    /* v599: Regler-Werte in ganzen Sekunden nachführen (nur bei Änderung) */
    var ariaNow = -1, ariaMax = -1;
    function setAria() {
      var dur = audio.duration > 0 && isFinite(audio.duration) ? audio.duration : 0;
      var max = Math.floor(dur), now = Math.min(max, Math.floor(audio.currentTime || 0));
      if (now === ariaNow && max === ariaMax) return;
      ariaNow = now; ariaMax = max;
      wave.setAttribute("aria-valuemax", String(max));
      wave.setAttribute("aria-valuenow", String(now));
      wave.setAttribute("aria-valuetext", max > 0 ? fmt(now) + " von " + fmt(max) : fmt(now));
    }
    var started = false;

    function setIcon(playing) { btn.innerHTML = playing ? ICON_PAUSE : ICON_PLAY; }

    btn.addEventListener("click", function () {
      if (audio.paused) {
        if (!srcSet) { audio.src = src; srcSet = true; }
        /* andere Player stoppen */
        players.forEach(function (a) { if (a !== audio && !a.paused) a.pause(); });
        audio.play();
        if (!started) { started = true; }
        trackPaged("voice_play", page, { page: page, rate: audio.playbackRate, pos: Math.round(audio.currentTime) });
      } else {
        audio.pause();
      }
    });
    audio.addEventListener("play", function () { setIcon(true); syncLiveClass(); updateBarFor(audio, host, title, page); });
    audio.addEventListener("pause", function () { setIcon(false); syncLiveClass(); updateBarFor(audio, host, title, page); });
    audio.addEventListener("ended", function () {
      setIcon(false);
      trackPaged("voice_complete", page, { page: page, rate: audio.playbackRate });
    });
    audio.addEventListener("loadedmetadata", function () {
      time.textContent = "0:00 / " + fmt(audio.duration);
      setAria();
    });
    audio.addEventListener("timeupdate", function () {
      if (audio.duration > 0) {
        paint(audio.currentTime / audio.duration);
        time.textContent = fmt(audio.currentTime) + " / " + fmt(audio.duration);
        setAria();
      }
      /* v373: Sichtbarkeit läuft nur während der Wiedergabe — genau dann ist die Mini-Bar relevant */
      updateBarFor(audio, host, title, page);
    });
    audio.addEventListener("ended", function () { paint(0); lastIdx = -1; syncLiveClass(); updateBarFor(audio, host, title, page); });
    wave.addEventListener("click", function (e) {
      /* v379: Vor dem ersten Play gibt es keine Dauer (MP3 lädt erst bei Klick) —
         ein Tipp auf die Wellen startet dann einfach die Wiedergabe statt zu schweigen. */
      if (!(audio.duration > 0)) { if (audio.paused) btn.click(); return; }
      var r = wave.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      audio.currentTime = p * audio.duration;
      paint(p);
    });
    /* v599: Tastatur am Regler: Pfeil links/rechts = 5 s zurück/vor, Pos1/Ende.
       Vor dem ersten Abspielen startet die Taste wie der Tipp oben die Wiedergabe. */
    wave.addEventListener("keydown", function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;   /* v599: Browser-Kürzel (Alt/Cmd+Pfeil = Zurück) nicht schlucken */
      var k = e.key, step = 0;
      if (k === "ArrowLeft" || k === "ArrowDown") step = -5;
      else if (k === "ArrowRight" || k === "ArrowUp") step = 5;
      else if (k !== "Home" && k !== "End") return;
      e.preventDefault();
      if (!(audio.duration > 0)) { if (audio.paused) btn.click(); return; }
      var t = k === "Home" ? 0 : k === "End" ? audio.duration : audio.currentTime + step;
      t = Math.min(audio.duration, Math.max(0, t));
      audio.currentTime = t;
      paint(t / audio.duration);
      setAria();
    });
    var rateBtn = host.querySelector(".ivp-rate");
    var rateIdx = 0;
    rateBtn.addEventListener("click", function () {
      rateIdx = (rateIdx + 1) % rates.length;
      var rate = rates[rateIdx];
      audio.playbackRate = rate;
      rateBtn.textContent = String(rate).replace(".", ",") + "×";
      track("voice_rate", { page: page, rate: rate });
    });

    players.push(audio);
  }

  function init() {
    var hosts = d.querySelectorAll("[data-iso-voice]");
    for (var i = 0; i < hosts.length; i++) build(hosts[i]);
  }
  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", init);
  else init();

  /* v374: Beim Verlassen der Seite (Navigation ODER Einfrieren in den
     Back-Forward-Cache) alle Audios sauber pausieren — sonst könnte eine
     per Zurück-Taste wiederhergestellte Seite einen falschen Spiel-Zustand
     zeigen. Normale Navigation stoppt Audio ohnehin (Seite wird entladen). */
  w.addEventListener("pagehide", function () {
    for (var i = 0; i < players.length; i++) {
      try { if (!players[i].paused) players[i].pause(); } catch (e) {}
    }
  });

  /* Hosts, die erst später ins DOM kommen (z. B. Ergebnisseite step-4),
     automatisch bauen — rAF-gedrosselter Observer.
     v599: init() nur noch, wenn ein neu eingefügtes Element ein Host ist oder
     einen enthält. Vorher lief init() nach jeder DOM-Änderung (auch nach jeder
     Zeitanzeige während der Wiedergabe) über das ganze Dokument. */
  function neuerHost(muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute("data-iso-voice") || n.querySelector("[data-iso-voice]")) return true;
      }
    }
    return false;
  }
  try {
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending || !neuerHost(muts)) return;
      pending = true;
      w.requestAnimationFrame(function () { pending = false; init(); });
    }).observe(d.documentElement, { childList: true, subtree: true });
  } catch (e) {}

})(window, document);
